import React from 'react';

/**
 * Reusable Metric Card Component
 * Displays a metric with label, value, and optional trend indicator
 */
const MetricCard = ({
    label,
    value,
    icon = null,
    trend = null, // 'up', 'down', or null
    trendValue = null,
    color = 'blue', // blue, green, yellow, red, purple
    size = 'md', // sm, md, lg
    className = ''
}) => {
    const colorClasses = {
        blue: 'bg-blue-900/30 border-blue-800 text-blue-400',
        green: 'bg-green-900/30 border-green-800 text-green-400',
        yellow: 'bg-yellow-900/30 border-yellow-800 text-yellow-400',
        red: 'bg-red-900/30 border-red-800 text-red-400',
        purple: 'bg-purple-900/30 border-purple-800 text-purple-400',
        gray: 'bg-gray-800 border-gray-700 text-gray-400'
    };

    const sizeClasses = {
        sm: 'p-2',
        md: 'p-3',
        lg: 'p-4'
    };

    const valueSizeClasses = {
        sm: 'text-lg font-bold',
        md: 'text-xl font-bold',
        lg: 'text-2xl font-bold'
    };

    const trendIcon = trend === 'up' ? (
        <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
    ) : trend === 'down' ? (
        <svg className="w-4 h-4 text-red-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
    ) : null;

    return (
        <div className={`rounded-lg border ${colorClasses[color]} ${sizeClasses[size]} ${className}`}>
            <div className="flex items-center justify-between">
                <div>
                    <p className="text-xs text-gray-400 uppercase tracking-wide">{label}</p>
                    <p className={`text-white ${valueSizeClasses[size]}`}>{value}</p>
                    {trend && trendValue && (
                        <div className="flex items-center gap-1 mt-1">
                            {trendIcon}
                            <span className={`text-xs ${trend === 'up' ? 'text-green-500' : 'text-red-500'}`}>
                                {trendValue}
                            </span>
                        </div>
                    )}
                </div>
                {icon && (
                    <div className="text-2xl opacity-50">{icon}</div>
                )}
            </div>
        </div>
    );
};

export default MetricCard;
